import {BatchDisplayStatus, BatchStatus, SettlementSearchCriteria, SettlementsSortField} from 'web-angular-client';

export class SettlementSearchCriteriaImpl implements SettlementSearchCriteria
{
    batchNumber?: number;
    displayStatus?: BatchDisplayStatus;
    settlementsSortField?: SettlementsSortField;
    status?: Array<BatchStatus>;
    totalAmountLower?: number;
    totalAmountSettledLower?: number;
    totalAmountSettledUpper?: number;
    totalAmountUpper?: number;
    totalTransactionFeesInclVatLower?: number;
    totalTransactionFeesInclVatUpper?: number;
    settlementFeeInclVatLower?: number;
    settlementFeeInclVatUpper?: number;
    totalTransactionsLower?: number;
    totalTransactionsUpper?: number;
    updatedLower?: string;
    updatedUpper?: string;

    constructor()
    {
        this.batchNumber = null;
        this.displayStatus = BatchDisplayStatus.ANY;
        this.settlementsSortField = null;
        this.status = [];
        this.totalAmountLower = null;
        this.totalAmountSettledLower = null;
        this.totalAmountSettledUpper = null;
        this.totalAmountUpper = null;
        this.totalTransactionFeesInclVatLower = null;
        this.totalTransactionFeesInclVatUpper = null;
        this.settlementFeeInclVatUpper = null;
        this.settlementFeeInclVatLower = null;
        this.totalTransactionsLower = null;
        this.totalTransactionsUpper = null;
        this.updatedLower = null;
        this.updatedUpper = null;
    }
}